import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../components/ui/accordion";
import { FAQS } from "../lib/_data";

export default function FAQSection({ subset }) {
  const items = subset ? FAQS.slice(0, subset) : FAQS;
  return (
    <section
      data-testid="faq-section"
      className="bg-[#f9f6f0] py-20 md:py-28"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <span className="text-xs tracking-[0.24em] uppercase font-bold text-[#c85a3c]">
            Answers
          </span>
          <h2 className="font-display text-3xl md:text-5xl font-black text-[#2c2a29] leading-[1.05] mt-4">
            Frequently asked questions
          </h2>
          <p className="mt-5 text-[#5c5855] leading-relaxed max-w-xl mx-auto">
            Everything you'd want to know before picking up the phone. Can't
            find your answer? Just call — a real person picks up.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-3">
          {items.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="bg-[#fffdf9] border border-[#e5e0d8] rounded-2xl px-6 md:px-8 last:border-b"
            >
              <AccordionTrigger className="text-left font-display font-bold text-lg md:text-xl text-[#2c2a29] hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5c5855] leading-relaxed text-[15px] pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
